module.exports = __webpack_public_path__ + "static/media/Lato-Bold.24b516c2.ttf";